
import type { LedsService } from 'commercial-web-client-utilities/dist/composables/leds-service';
import type { NonsecureService } from 'commercial-web-client-utilities/dist/composables/nonsecure-service';
import type { AxiosResponse } from 'axios';

export interface ProfileService {
    updateTermsAgreementDate(): Promise<AxiosResponse>;
}

export interface CreateProfileServiceOptions {
    ledsService: LedsService;
    nonsecureService: NonsecureService;
}

/**
 * Creates service for updating profile information
 * @param serviceOptions {CreateProfileServiceOptions}
 * @returns ProfileService
 */
export function createProfileService(
    serviceOptions: CreateProfileServiceOptions
): ProfileService {
    const {
        ledsService,
        nonsecureService,
    } = serviceOptions;

    const ledsClient = ledsService.client;
    const nonsecureClient = nonsecureService.client;

    async function updateTermsAgreementDate(): Promise<AxiosResponse> {
        const headers = await ledsService.createAuthorizationHeaders();
        const sessionToken = localStorage.getItem('sessionToken');
        if (sessionToken) {
            headers.Authorization = `Bearer ${sessionToken}`;
        }
        const today = new Date();
        return await nonsecureClient.put(
            `${ledsClient.defaults.baseURL?.replace(/\/$/, '')}/member/profile`,
            {
                lastUsageAgreementDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1)
                    .toISOString().split('T')[0],
            },
            {
                headers,
            },
        );
    }

    return {
        updateTermsAgreementDate,
    };
}